export default ({...props}) => {
  const {space, borderColor} = props.theme
  return `
    display: flex;
    flex-flow: column;
    gap: ${space(3.875)}px;
    margin: 0 ${space(2)}px ${space(2)}px;
    padding: 0;
    & p {
        margin-bottom: 0;
    }

    @media screen and (max-width:480px) {
        padding-top: ${space(2)}px;
        border-top: 1px solid ${borderColor.main};
    }`
}
